import { loadExpiringDismissalsMap, pruneDismissalsStaleAfterOneDay, saveExpiringDismissalsMap } from './expiringDismissalsMap'
import moment from 'moment'

const SITE_BANNER_DISMISSALS_KEY = 'siteBannerDismissals'
const SITE_BANNER_DISMISSALS_VERSION = 1

function getDismissals() {
  return loadExpiringDismissalsMap(SITE_BANNER_DISMISSALS_KEY, SITE_BANNER_DISMISSALS_VERSION)
}

export function recordSiteBannerDismissal(bannerId: string, bannerEndDate: string) {
  const dismissals = getDismissals()

  pruneDismissalsStaleAfterOneDay(dismissals, moment())

  dismissals[bannerId] = { endDate: bannerEndDate }
  saveExpiringDismissalsMap(SITE_BANNER_DISMISSALS_KEY, SITE_BANNER_DISMISSALS_VERSION, dismissals)
}

export function isBannerDismissed(bannerId: string): boolean {
  const dismissals = getDismissals()
  const dismissal = dismissals[bannerId]

  if (!dismissal) {
    return false
  }

  // Check if the dismissal has expired
  const now = moment()
  const expiry = moment(dismissal.endDate)

  if (now.isAfter(expiry)) {
    // Dismissal has expired, clean it up and return false
    delete dismissals[bannerId]
    saveExpiringDismissalsMap(SITE_BANNER_DISMISSALS_KEY, SITE_BANNER_DISMISSALS_VERSION, dismissals)
    return false
  }

  return true
}

export function getDismissedBannerIds(): Set<string> {
  const dismissals = getDismissals()
  const now = moment()

  // Filter out expired dismissals
  const validBannerIds = Object.keys(dismissals).filter(bannerId => {
    const expiry = moment(dismissals[bannerId].endDate)
    return now.isBefore(expiry) || now.isSame(expiry)
  })

  return new Set(validBannerIds)
}
